var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2222 3.7793H3.77776C3.10275 3.7793 2.55554 4.3265 2.55554 5.00152V29.446C2.55554 30.121 3.10275 30.6682 3.77776 30.6682H28.2222C28.8972 30.6682 29.4444 30.121 29.4444 29.446V5.00152C29.4444 4.3265 28.8972 3.7793 28.2222 3.7793Z",
    stroke: "#2B6A6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 1.33398V6.22287",
    stroke: "#2B6A6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66577 1.33398V6.22287",
    stroke: "#2B6A6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.55554 11.1113H29.4444",
    stroke: "#2B6A6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 17.2227H14.7781L12.3337 20.2782C12.736 20.2775 13.1322 20.3761 13.4873 20.5653C13.8423 20.7545 14.1452 21.0283 14.369 21.3626C14.5929 21.6969 14.7307 22.0812 14.7704 22.4816C14.8101 22.8819 14.7503 23.2858 14.5965 23.6575C14.4426 24.0292 14.1994 24.3572 13.8884 24.6124C13.5774 24.8676 13.2082 25.0421 12.8136 25.1204C12.419 25.1987 12.0112 25.1783 11.6263 25.0612C11.2415 24.9441 10.8914 24.7339 10.6073 24.449",
    stroke: "#2B6A6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4453 19.056L20.8898 17.2227V25.1671",
    stroke: "#2B6A6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule-icon.97c1aae48c3a139590216f5b49e62492.svg";
export { ForwardRef as ReactComponent };